import produce from 'immer';

import {
  INVITE_UPDATED,
  CARD_RECEIVED,
  SESSION_RECEIVED,
  INVITATION_ERROR,
  INVITATION_RECEIVED,
  SESSION_AUTH_INVALID,
  SESSION_AUTH_RECEIVED,
  SESSION_VERIFY_RECEIVED,
  SESSION_RESET_SUCCESS,
  INVITATIONS_RECEIVED,
  SESSION_REGISTRATION_RECEIVED
} from 'constants/actions';

export var INITIAL_STATE = {
  card: null,
  isAuth: false,
  invitations: [],
  invitationError: null,
  lastPasswordReset: null,
  updated: null
};

export const order = produce((draft, action) => {
  switch (action.type) {
    case CARD_RECEIVED:
      draft.card = action.value;
      return draft;

    case SESSION_AUTH_RECEIVED:
      draft = { ...draft, ...action.value, isAuth: true };
      return draft;

    case SESSION_AUTH_INVALID:
      draft = INITIAL_STATE;
      return draft;

    case SESSION_VERIFY_RECEIVED:
      draft = { ...draft, ...action.value, isAuth: true };
      return draft;

    case SESSION_RECEIVED:
      draft = { ...draft, ...action.value };
      return draft;

    case SESSION_REGISTRATION_RECEIVED:
      draft = { ...draft, registerSubmitted: Date.now() };
      return draft;

    case SESSION_RESET_SUCCESS:
      draft = { ...draft, lastPasswordReset: Date.now() };
      return draft;

    case INVITATION_RECEIVED: 
      let index = draft.invitations.findIndex(({ id }) => id === action.value.id);

      ~index
        ? (draft.invitations[index] = { ...draft.invitations[index], ...action.value })
        : draft.invitations.push(action.value);

      return draft;

    case INVITATIONS_RECEIVED:
      draft.invitations = action.value;
      return draft;

    case INVITE_UPDATED:
      draft.invitations = draft.invitations.filter(i => i.id !== action.value);
      return draft;

    case INVITATION_ERROR:
      draft.invitationError = true;
      return draft;

    default:
      return draft;
  }
}, INITIAL_STATE);

export default order;
